import React, { useEffect, useState } from 'react';
import { Col } from 'antd';
import { I18n } from '@aws-amplify/core';

import { ErgonomicToolKeys } from '../../../enums';
import ButtonDefault from '@/components/ui/ButtonDefault';
import { ErgonomicRiskBadge } from '../ErgonomicRiskBadge';
import { useResolution886Report } from '@/context/Resolution886Report';
import {
	NioshReportIcon,
	RebaReportIcon,
	LibertyMutualReportIcon,
	KimPushPullReportIcon,
	StrainIndexReportIcon
} from '@/assets/icons';
import type { RelatedReport } from '@/context/Resolution886Report/types';
import * as S from './styles';

interface ToolsProps {
	relatedReport: RelatedReport | null;
	category_key: string;
	category_name: string;
	tool: string | null;
	name: string | null;
}

interface ToolIconLink {
	tool: string;
	link: string;
	icon: JSX.Element;
}

export function DefaultTools({ tool, name, category_name, relatedReport }: Readonly<ToolsProps>): JSX.Element {
	const [link, setLink] = useState<string | null>(null);
	const [fileId, setFileId] = useState<string | null>(null);

	const { assessment } = useResolution886Report();

	const toolIconLink: ToolIconLink[] = [
		{
			tool: ErgonomicToolKeys.NIOSH,
			icon: <NioshReportIcon />,
			link: `/reporting/niosh/${fileId}`
		},
		{
			tool: ErgonomicToolKeys.KIM_PP,
			icon: <KimPushPullReportIcon />,
			link: `/reporting/kim-pp/${fileId}`
		},
		{
			tool: ErgonomicToolKeys.STRAIN_INDEX,
			icon: <StrainIndexReportIcon />,
			link: `/reporting/strain-index/${fileId}`
		},
		{
			tool: ErgonomicToolKeys.REBA,
			icon: <RebaReportIcon />,
			link: `/reporting/reba/${fileId}`
		},
		{
			tool: ErgonomicToolKeys.LIBERTY_MUTUAL,
			icon: <LibertyMutualReportIcon />,
			link: `/reporting/liberty-mutual/${fileId}`
		}
	];

	function handleTool(tool: string): JSX.Element {
		const toolIcon = toolIconLink.find((item) => item.tool === tool)?.icon || <></>;
		return toolIcon;
	}

	function handleSetlink(): void {
		const toolLink = toolIconLink.find((item) => item.tool === tool)?.link || '';
		setLink(toolLink);
	}

	useEffect(() => {
		if (assessment) {
			setFileId(assessment.file.id);
		}
	}, [assessment]);

	useEffect(() => {
		if (tool && fileId) {
			handleSetlink();
		}
	}, [fileId, tool]);

	function handleFillToolOnClick(): void {
		link && window.open(link, '_blank');
	}

	const toolName = I18n.get('ErgonomicTool886').replace('{{tool_name}}', name || '');

	return (
		<Col span={24} xl={12} style={{ padding: '0 20px 0 30px' }}>
			<S.CustomLabel>{toolName}</S.CustomLabel>
			<S.CustomButton onClick={handleFillToolOnClick}>
				<S.CustomContainerTooltip>
					{tool && handleTool(tool)}
					<div className="content-tool">
						<h4>{I18n.get(category_name)}</h4>
						<p>{name}</p>
					</div>
				</S.CustomContainerTooltip>
				{relatedReport ? (
					<ErgonomicRiskBadge relatedReport={relatedReport} />
				) : (
					<ButtonDefault onClick={handleFillToolOnClick}>{I18n.get('Fill tool')}</ButtonDefault>
				)}
			</S.CustomButton>
		</Col>
	);
}
